import type { StaffRole } from '@/types/backoffice'

const ACCESS_TOKEN_KEY = 'tp_staff_access_token'

export interface StaffTokenPayload {
  sub: string
  role: StaffRole
  name: string
  scope: 'staff'
  exp: number
}

export function getStaffAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

export function setStaffAccessToken(token: string): void {
  localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

export function clearStaffAccessToken(): void {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
}

export function getStaffTokenPayload(): StaffTokenPayload | null {
  const token = getStaffAccessToken()
  if (!token) return null
  try {
    const raw = token.split('.')[1]
    if (!raw) return null
    const base64 = raw.replaceAll('-', '+').replaceAll('_', '/').padEnd(Math.ceil(raw.length / 4) * 4, '=')
    return JSON.parse(atob(base64)) as StaffTokenPayload
  } catch {
    return null
  }
}

export function isStaffAuthenticated(): boolean {
  const payload = getStaffTokenPayload()
  if (!payload) return false
  return payload.exp * 1000 > Date.now()
}
